import React, { useState } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, defs } from "recharts";
import './styles.scss';  // Optional: for styling

// const data = [
//   { name: "SUN", value: 70 },
//   { name: "MON", value: 95 },
//   { name: "TUE", value: 60 },
//   { name: "WED", value: 150 },
//   { name: "THU", value: 120 },
//   { name: "FRI", value: 110 },
//   { name: "SAT", value: 80 },
 
// ];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p>{`${payload[0].value} Requests`}</p>
      </div>
    );
  }
  return null;
};

const PurchaseRequestsChart = ({chartData}) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const handleMouseEnter = (index) => setHoveredIndex(index);
  const handleMouseLeave = () => setHoveredIndex(null);


  return (
    <div className="chart-container">
      <ResponsiveContainer width="100%" height={'100%'}>
        {Object.entries(chartData).length !== 0 ?
        <LineChart 
        data={chartData} 
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
      >
        <defs>
          <filter id="shadow" height="130%">
            <feDropShadow dx="2" dy="2" stdDeviation="3" floodColor="#888888" />
          </filter>
        </defs>
        <CartesianGrid vertical={false} horizontal={false} />
        <XAxis 
          dataKey="name" 
          stroke="#888888" 
          axisLine={false} 
          tickLine={false} 
          tickMargin={28}
          dy={15} // Adjust vertical position of x-axis labels
          tick={({x, y, payload}) => (
            <g
              onMouseEnter={() => handleMouseEnter(chartData.findIndex(d => d.name === payload.value))}
              onMouseLeave={handleMouseLeave}
            >
              <rect
                x={x - 22}  // Center box on the tick label
                y={10}       // Start from above the x-axis labels
                width={"5%"}   // Increased width
                height={"90%"} // Covering full height of the chart
                fill={hoveredIndex === chartData.findIndex(d => d.name === payload.value) ? '#696969' : '#DCDCDC'}
                opacity={0.3}
                rx={15}   // Adding border radius
                ry={15}   // Adding border radius
              />
              <text x={x} y={y + 15} textAnchor="middle" fill="#888888">
                {payload.value}
              </text>
            </g>
          )}
          interval={0} // Show all x-axis labels
        />
        <YAxis 
          // domain={[0, 200]} 
          stroke="#888888" 
          axisLine={false} 
          tickLine={false} 
          tickMargin={40}
        />
        <Tooltip 
          content={<CustomTooltip />} 
          cursor={false}  // Disable the vertical line
        />
        <Line 
          type="linear" 
          dataKey="value" 
          stroke="#1A194F" 
          strokeWidth={3} 
          dot={(dotProps) => 
            hoveredIndex === dotProps.index 
              ? <circle cx={dotProps.cx} cy={dotProps.cy} r={5} stroke="#1A194F" strokeWidth={2} fill="#fff" />
              : null
          }
          activeDot={{ r: 8 }} 
          style={{ filter: 'url(#shadow)' }} // Applying the shadow filter here
        />
      </LineChart>
       : <p style={{textAlign:"center"}}>Loading</p>}
        
      </ResponsiveContainer>
    </div>
  );
};

export default PurchaseRequestsChart;
